(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));

  var lenis = typeof Lenis !== 'undefined'
    ? new Lenis({
        duration: 1.1,
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1.5,
        autoRaf: false,
      })
    : null;

  function updateParallax() {
    var viewportHeight = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var rect = el.getBoundingClientRect();
      var centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
      var offset = -centerOffset * speed;
      var maxOffset = 60;
      offset = Math.max(-maxOffset, Math.min(maxOffset, offset));
      el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
    });
  }

  function raf(time) {
    if (lenis) lenis.raf(time);
    if (parallaxEls.length) updateParallax();
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
})();
